import routeReplaceSelf from '@/utils/routeReplaceSelf';
const custTempManagement = {
    path: "custTempManagement",
    name: "custTempManagement",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'templateManagement',
        icon: 'HSIconfont hs-icon-ap',
        showRealm: ['SYSTEM']
    },
    children: [
        {
            path: 'custTemplateProject',
            name: 'custTemplateProject',
            component: routeReplaceSelf(() => import('@/views/custTemplateProject/index.vue')),
            meta: { code: 'templateManagement:project' },
            children: [
                {
                    path: 'custTemProjectDetail',
                    name: 'custTemProjectDetail',
                    hidden: true,
                    component: () => import('@/views/custTemplateProject/components/ProjectDetail.vue'),
                    meta: {
                        code: 'templateManagement_project_retrieve',
                        reName: 'label.details',
                        activeMenu: 'custTemplateProject',
                    },
                },
            ]
        },
        {
            path: 'custTemplatePublish',
            name: 'custTemplatePublish',
            component: routeReplaceSelf(() => import('@/views/custTemplatePublish/index.vue')),
            meta: { code: 'templateManagement:publish' },
            children: [
                {
                    path: 'custTemPublishAdd',
                    name: 'custTemPublishAdd',
                    hidden: true,
                    component: () => import('@/views/custTemplatePublish/components/custTemPublishAdd.vue'),
                    meta: {
                        code: 'templateManagement_publish_create',
                        activeMenu: 'custTemplatePublish',
                    },
                },
                {
                    path: 'custTemPublishEdit',
                    name: 'custTemPublishEdit',
                    hidden: true,
                    component: () => import('@/views/custTemplatePublish/components/custTemPublishEdit.vue'),
                    meta: {
                        code: 'templateManagement_publish_update',
                        activeMenu: 'custTemplatePublish',
                    },
                }
            ],
        }
    ]
};
export default custTempManagement;
